<template>
  <div>
    <a-row>
      <g-master name="poll_category"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                ref="master"
                :parentData="ParentData"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Nombre')">
                <a-input
                  v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Operador')">
                <a-select
                  v-decorator="[
                    'operador',
                    { rules: [{ required: true, message: 'Valor requerido' }], initialValue: 'OR' },
                  ]"
                >
                  <a-select-option value="AND">
                    AND
                  </a-select-option>
                  <a-select-option value="OR">
                    OR
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Estado')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="2">
        <a-tab-pane tab="CONDICIONES" key="2">
          <mantenimiento-poll-rule-conds v-if="idForm" :id="idForm" :poll-id="id"></mantenimiento-poll-rule-conds>
          <span v-else>Seleccione para ver más.</span>
        </a-tab-pane>
        <a-tab-pane tab="ACCIONES" key="1">
          <mantenimiento-poll-rule-acts v-if="idForm" :id="idForm" :poll-id="id"></mantenimiento-poll-rule-acts>
          <span v-else>Seleccione para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipo_pregunta: {h_lookup_type: 'TIPO_PREGUNTA'},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'poll_rule',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Operador', dataIndex: 'operador', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'status', type: 'boolean'},
            {name: 'operador'}
          ]
        }
      }
    },
    props: ['id'],
    computed: {
      ParentData () {
        return {
          id_poll: this.id
        }
      },
      idForm () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Poll/PollRules.vue